import React from "react";
import { Col, Row } from "react-bootstrap";
import { useGetCrmDashboard } from "../../hooks/useCrm";
import { useGetDashboard } from "../../hooks/useSupplier";
import { SummeryCard } from "../SummaryCard/SummeryCard";
import row1_1IconCrm from "../../assets/icons/blogging.svg";
import row1_2IconCrm from "../../assets/icons/list.svg";
import row1_3IconCrm from "../../assets/icons/gallery.svg";
import row1_4IconCrm from "../../assets/icons/features.svg";
import row2_1IconCrm from "../../assets/icons/brand.svg";
import row2_2IconCrm from "../../assets/icons/list.svg";
import row2_3IconCrm from "../../assets/icons/list.svg";
import row2_4IconCrm from "../../assets/icons/list.svg";
import row3_1IconCrm from "../../assets/icons/stop.svg";
import row3_2IconCrm from "../../assets/icons/unavailablelocation.svg";
import row3_3IconCrm from "../../assets/icons/lifestyles.svg";
import row3_4IconCrm from "../../assets/icons/online.svg";
export const SupplierDashboard = () => {
  const { data } = useGetDashboard();
  const blogsInfo = data?.data?.blogsInfo;
  const categoriesInfo = data?.data?.categoriesInfo;
  const productsInfo = data?.data?.productsInfo;

  return (
    <Row>
      <Col lg={4}>
        <SummeryCard
          title={"اطالاعات اولیه"}
          Amount={blogsInfo?.City}
          bgColor={"#50cd89"}
          subtitle={"شهر های تحت پوشش"}
          onlineOrderTitle={"وبلاگ ها"}
          offlineOrderTitle={"دسته بندی وبلاگ ها"}
          invoiceOrderTitle={"اسلایدر ها "}
          unsuccessfullTitle={"دسته بندی ویژگی محصولات"}
          onlineOrder={blogsInfo?.articles}
          offlineOrder={blogsInfo?.blogCategories}
          invoiceOrder={blogsInfo?.sliders}
          unsuccessfull={blogsInfo?.FeatureValues}
          row1Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row1_1IconCrm}
              alt="row1_1IconCrm"
            />
          }
          row2Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row1_2IconCrm}
              alt="row1_2IconCrm"
            />
          }
          row3Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row1_3IconCrm}
              alt="row1_3IconCrm"
            />
          }
          row4Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row1_4IconCrm}
              alt="row1_4IconCrm"
            />
          }
          // pathName1={pathName3_1}
          // pathName2={pathName3_2}
          // pathName3={pathName3_3}
          // pathName4={pathName3_4}
        />
      </Col>
      <Col lg={4}>
        <SummeryCard
          title={"اطلاعات دسته بندی ها"}
          Amount={
            +categoriesInfo?.categoryLevel1 +
            +categoriesInfo?.categoryLevel2 +
            +categoriesInfo?.categoryLevel3
          }
          pathname={"/dashboard/accounting/orders"}
          bgColor={"#009ef7"}
          subtitle={"دسته بندی"}
          onlineOrderTitle={"برند ها"}
          offlineOrderTitle={"دسته بندی یک"}
          invoiceOrderTitle={"دسته بندی دو"}
          unsuccessfullTitle={"دسته بندی سه"}
          onlineOrder={categoriesInfo?.brands}
          offlineOrder={categoriesInfo?.categoryLevel1}
          invoiceOrder={categoriesInfo?.categoryLevel2}
          unsuccessfull={categoriesInfo?.categoryLevel3}
          row1Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row2_1IconCrm}
              alt="row2_1IconCrm"
            />
          }
          row2Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row2_2IconCrm}
              alt="row2_2IconCrm"
            />
          }
          row3Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row2_3IconCrm}
              alt="row2_3IconCrm"
            />
          }
          row4Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row2_4IconCrm}
              alt="row2_4IconCrm"
            />
          }
          // pathName1={pathName1_1}
          // pathName2={pathName1_2}
          // pathName3={pathName1_3}
          // pathName4={pathName1_4}
        />
      </Col>
      <Col lg={4}>
        <SummeryCard
          title={"اطلاعات محصولات"}
          Amount={productsInfo?.products}
          bgColor={"#f1416c"}
          subtitle={"همه محصولات"}
          onlineOrderTitle={"محصولات ناموجود"}
          offlineOrderTitle={"محصولات راکد"}
          invoiceOrderTitle={"محصولات فعال"}
          unsuccessfullTitle={"محصولات در حال بررسی"}
          onlineOrder={productsInfo?.NotExistProducts}
          offlineOrder={productsInfo?.NotActiveProducts}
          invoiceOrder={productsInfo?.ActiveProducts}
          unsuccessfull={productsInfo?.PROGRESS}
          row1Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row3_1IconCrm}
              alt="row3_1IconCrm"
            />
          }
          row2Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row3_2IconCrm}
              alt="row3_2IconCrm"
            />
          }
          row3Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row3_3IconCrm}
              alt="row3_3IconCrm"
            />
          }
          row4Icon={
            <img
              style={{ margin: "0 auto" }}
              className="img-fluid"
              src={row3_4IconCrm}
              alt="row3_4IconCrm"
            />
          }
          // pathName1={pathName2_1}
          // pathName2={pathName2_2}
          // pathName3={pathName2_3}
          // pathName4={pathName2_4}
        />
      </Col>
    </Row>
  );
};
